export const SITE_MODULATION_PERFORMANCE_CARD_FRENCH_LOCALE = {
  title: "Effacements",
  subtitle: "7 derniers jours",
  state: {
    UNKNOWN: "Inconnu",
    NONE: "Aucun",
    NOT_TESTED: "Non Testé",
    KO_DETECTED: "Pb. Détecté",
    SUCCESS: "OK",
  },
};
